/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:33 PM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Promotion = module.exports = SoaModel.extend();

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');
var Adjustment = require('bunsen/models/ecomm/Adjustment');
var Rule = require('bunsen/models/ecomm/Rule');
var Anchor = require('bunsen/models/Anchor');
var ruleTypes = ['ItemList', 'DealerList', 'BuyerList', 'PurchaseHistory', 'VerticalList', 'PriceRange', 'UsesPerBuyer', 'UsesPerCode'];
var ruleTypeMap = {
    'ItemList': [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK],
    'DealerList': [Rule.TYPE_DEALER_WHITE, Rule.TYPE_DEALER_BLACK],
    'BuyerList': [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK],
    'PurchaseHistory': [Rule.TYPE_PURCHASE_HISTORY],
    'VerticalList': [Rule.TYPE_VERTICAL_WHITE],
    'PriceRange': [Rule.TYPE_PRICE_RANGE],
    'UsesPerBuyer': [Rule.TYPE_USES_PER_BUYER],
    'UsesPerCode': [Rule.TYPE_USES_PER_CODE],
    'VerifiedTradeBuyer': [Rule.TYPE_VERIFIED_TRADE]
};
var buyerErrors = ["USES_PER_BUYER_EXCEEDED_ERROR", "BUYER_BLACKLIST_ERROR", "BUYER_WHITELIST_ERROR", "PURCHASE_HISTORY_ERROR"];

// ---------------------------------------------------
// Factory Methods
var getAdjustmentRateByApiType = function (apiType) {
    var adjustmentRateList = this.get('adjustmentRateList');
    if (adjustmentRateList) {
        return adjustmentRateList.findWhere({apiType: apiType});
    }
};

var hasAdjustmentRateApiType = function () {
    return !!getAdjustmentRateByApiType.apply(this, arguments);
};

var setAdjustment = function (apiType, rate, eligibleAmount) {
    // you can only have one adjustment for now
    this.set('adjustmentRateList', [{
        apiType: apiType,
        reference: Adjustment.REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT,
        rate: rate,
        eligibleAmount: eligibleAmount,
        calculationTarget: {
            documentType : 'OFFER'
        }
    }]);
};

/**
 * @param {array} apiTypes
 */
var getRule = function (apiTypes) {
    var self = this;
    var rule;

    _.find(apiTypes, function (apiType) {
        rule = self.get('ruleList').findWhere({ apiType: apiType });
        return rule;
    });

    return rule;
};

/**
 * @param {array} apiTypes
 */
var removeRule = function (apiTypes) {
    var ruleList = this.get('ruleList');

    _.each(apiTypes, function (apiType) {
        return ruleList.remove(ruleList.where({ apiType: apiType }));
    });

    return this;
};

var addRule = function (apiType, name, sourceType, ids, note) {
    return this._addSingletonRule(apiType, Rule.createRule(apiType, name, sourceType, ids, note));
};

var addBlackWhiteRule = function (apiType, name, sourceType, conflictingRuleName, ids, note) {
    var conflictingRule = getRule.call(this, [conflictingRuleName]);

    if (conflictingRule) {
        removeRule.call(this, [conflictingRuleName]);
    }

    addRule.call(this, apiType, name, sourceType, ids, note);
};

var getRuleTypeFunctions = function (functionPrefix, baseFunction) {
    var ret = {};

    _.each(ruleTypes, function (ruleType) {
        ret[functionPrefix + ruleType + 'Rule'] = _.partial(baseFunction, ruleTypeMap[ruleType]);
    });

    return ret;
};
var getRuleGetters = _.partial(getRuleTypeFunctions, 'get', getRule);
var getRuleRemovers = _.partial(getRuleTypeFunctions, 'remove', removeRule);

// ---------------------------------------------------
// Instance Properties
_.extend(Promotion.prototype, {
    url: function () {
        return endpoints.promotion(this.id);
    },
    defaults: {
        'ruleList': [],
        'source': {
            'role': 'INTERNAL'
        }
    },
    relations: SoaModel.createRelations([
        'validationResult',
        {
            key: 'adjustmentRateList',
            type: Backbone.Many,
            relatedModel: Adjustment
        },
        {
            key: 'ruleList',
            type: Backbone.Many,
            relatedModel: Rule
        }
    ]),
    activate: function () {
        return this.set('status', 'ENABLED').save();
    },
    isDraft: function () {
        return this.get('status') === 'DRAFT';
    },
    isInvalid: function () {
        var validationSuccess = this.get('validationResult.success');
        return _.isBoolean(validationSuccess) ? !validationSuccess : false;
    },
    isActive: function () {
        return !this.isNew() && !this.isInvalid();
    },
    getDiscountRate: function () {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.get('rate');
    },
    getEligibleAmount: function (currency) {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.getEligibleAmount(currency);
    },
    getEligibleAmountCurrency: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        return eligibleAmount && eligibleAmount.get('currency');
    },
    hasEligibleAmount: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        var amount = eligibleAmount && eligibleAmount.get('amount');
        return $.isNumeric(amount) && Number(amount) !== 0;
    },
    hasBuyerError: function () {
        return _.contains(buyerErrors, this.get('validationResult.code'));
    },
    getDiscountCurrency: function () {
        return this.getFlatDiscountCurrency() || this.getEligibleAmountCurrency();
    },
    isPercentDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_PERCENT),
    isFlatDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_FLAT),
    getFlatDiscountCurrency: function () {
        return this.isFlatDiscount() && this.get('adjustmentRateList[0].rate.currency');
    },
    setFlatAdjustment: function (amount, currency) {
        setAdjustment.call(this, Adjustment.APITYPE_FLAT, {amount: amount, currency: currency});
    },
    setPercentAdjustment: function (rate, eligibleAmount, eligibleAmountCurrency) {
        var eligibleAmountObj;

        if (eligibleAmount) {
            eligibleAmountObj = {amount: eligibleAmount, currency: eligibleAmountCurrency};
        }

        setAdjustment.call(this, Adjustment.APITYPE_PERCENT, rate, eligibleAmountObj);
    },
    _addSingletonRule: function (apiType, rule) {
        //only one rule of each kind can exist at a time
        removeRule.call(this, [apiType]);

        if (rule) {
            return this.get('ruleList').add(rule);
        }
    },
    addPriceRangeRule: function (currency, minAmount, maxAmount) {
        this._addSingletonRule(Rule.TYPE_PRICE_RANGE, Rule.createPriceRangeRule(currency, minAmount, maxAmount));
    },
    addHistoryTimePeriodRule: function (days) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createHistoryTimePeriodRule(days));
    },
    addPurchaseHistoryRule: function (startDate, endDate) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createPurchaseHistoryRule(startDate, endDate));
    },
    addVerifiedTradeRule: function () {
        return this._addSingletonRule(Rule.TYPE_VERIFIED_TRADE, Rule.createVerifiedTradeRule());
    },
    removeVerifiedTradeRule : function () {
        return removeRule.call(this, [Rule.TYPE_VERIFIED_TRADE]);
    },
    addUsesPerBuyerRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_BUYER, Rule.createUsesPerBuyerRule(numberOfUses));
    },
    addUsesPerCodeRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_CODE, Rule.createUsesPerCodeRule(numberOfUses));
    },
    addIdsToCustomerList: function (ids, note) {
        var rule = this.getBuyerListRule();
        return rule.addIdsToCustomerList(ids, note);
    },

    addItemWhitelistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_WHITE, 'Item Whitelist', Anchor.TYPE_ITEM, 'itemBlacklistRule'),
    addItemBlacklistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_BLACK, 'Item Blacklist', Anchor.TYPE_ITEM, 'itemWhitelistRule'),
    addDealerWhitelistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_WHITE, 'Dealer Whitelist', Anchor.TYPE_SELLER, 'dealerBlacklistRule'),
    addDealerBlacklistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_BLACK, 'Dealer Blacklist', Anchor.TYPE_SELLER, 'dealerWhitelistRule'),
    addBuyerWhitelistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_WHITE, 'Buyer Whitelist', Anchor.TYPE_USER, 'buyerBlacklistRule'),
    addBuyerBlacklistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_BLACK, 'Buyer Blacklist', Anchor.TYPE_USER, 'buyerWhitelistRule'),
    addVerticalWhitelistRule:    _.partial(addBlackWhiteRule, Rule.TYPE_VERTICAL_WHITE, 'Vertical Whitelist', Anchor.TYPE_VERTICAL, 'verticalWhitelistRule')
}, getRuleGetters(), getRuleRemovers());



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Promotion.js
// module id = 175
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54